
import { ref } from "vue";
import Form from "../helpers/form";
import { uploadVideo } from "../helpers/functions";
import { reactive } from "vue";

export default {
  name: "video-uploader",
  props: {
    name: String,
    form: Form,
    width: {
      type: String,
      default: () => "16px",
    },
    height: {
      type: String,
      default: () => "16px",
    },
    placeholder: {
      type: String,
      default: () => "N/A",
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
    accept: {
      type: String,
      default: () => "video/mp4",
    },
    uploadPermission: {
      type: String,
      default: () => "videos.upload",
    },
  },
  setup(props, { emit }) {
    const processing = ref(false);

    const processValues = reactive({
      text: "",
      percentage: 0,
    });
    const upload = (event) => {
      processing.value = true;
      uploadVideo(
        (text: string, current: number, total: number) => {
          processValues.text = text;
          processValues.percentage = (current * 100) / total;
        },
        event.target.files[0],
        event.target.files[0].size
      )
        .then((video) => {
          emit("change", video);
          props.form.update({ [props.name]: video });
          processing.value = false;
        })
        .catch(() => {
          emit("change", null);
          props.form.update({ [props.name]: null });
        });
    };
    return {
      processing,
      processValues,
      upload,
    };
  },
};
